/**
 * Sanitize a string for use as an HTML id attribute (HTML5 compliant).
 * Replaces invalid characters with hyphens, collapses consecutive hyphens,
 * and trims leading/trailing hyphens.
 */
function sanitizeId(str: string | null | undefined): string {
  if (str == null || typeof str !== 'string') {
    return '';
  }
  return str
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export default sanitizeId;
